/**
 * @todo 일부 DicomParser 내부 함수에 의존적인 코드 제거 이후, DicomParser import 코드 제거
 */

/* eslint-disable */
import DicomParser from "dicom-parser";
import LoaderParserLibs from "./loaderParserLibs";
import FloatMessageBox from "core/messageBoxController/index";
import { decodeDicomText } from "core/helper/dicomText";
import { RLEDecoder } from "decoder.rle";
// import openJPEG from "OpenJPEG.js";
// OpenJPEG.js 패키지의 commonJS 빌드는 아무것도 export 하지 않아 import 로는 쓸 수 없다.
// 브라우저 빌드를 public/index.html 의 <script> 로 읽어 전역 OpenJPEG() 를 쓴다 (_decodeJ2K).
// isolatedmodules error modifying
import Jpeg from "jpeg-lossless-decoder-js";
import { JpxImage } from "jpx";
import JpegImage from "jpeg";
import dumpDataSet from "component/molecules/popupDICOMTags/dumpDataSet";
import Config from "config";

// for temp
//let openJPEG; // for one time initialization
let openJPEG = null; // OpenJPEG 디코더 (처음 JPEG 2000 을 풀 때 한 번 만든다)
function trimNull(a) {
  if (!a) {
    return undefined;
  }
  var c = a.indexOf("\0");
  if (c > -1) {
    return a.substr(0, c);
  }
  return a;
}
function stringToNumber(numberAsString) {
  let number = Number(numberAsString);

  // returns true is number is NaN
  if (number !== number) {
    const dots = (numberAsString.match(/\./g) || []).length;
    const commas = (numberAsString.match(/\,/g) || []).length;

    if (commas === 1 && dots < 2) {
      // convert 1,45 to 1.45
      // convert 1,456.78 to 1456.78
      const replaceBy = dots === 0 ? "." : "";
      const stringWithoutComma = numberAsString.replace(/,/g, replaceBy);
      number = Number(stringWithoutComma);
    }

    // if that didn't help
    // weird stuff happenning
    // should throw an error instead of setting value to 1.0
    if (number !== number) {
      console.error(
        `String could not be converted to number (${numberAsString}). Setting value to "1.0".`
      );
      number = 1.0;
    }
  }

  return number;
}

// IAID-DicomParser 로 읽을 수 있는 Transfer Syntax (비압축 Little Endian)
const NS_LOADER_TRANSFER_SYNTAXES = [
  "1.2.840.10008.1.2", // Implicit VR Little Endian
  "1.2.840.10008.1.2.1", // Explicit VR Little Endian
];

/**
 * 파일 메타 헤더(0002 그룹)의 Transfer Syntax 만 먼저 읽어 IAID 파서를 써도 되는지 판단한다.
 * 메타 헤더가 없거나 읽지 못하면 지금까지처럼 IAID 파서를 쓴다.
 */
function canUseNSLoader(data) {
  try {
    const meta = DicomParser.readPart10Header(new Uint8Array(data));
    const ts = trimNull(meta.string("x00020010"));
    return !ts || NS_LOADER_TRANSFER_SYNTAXES.indexOf(ts.trim()) !== -1;
  } catch (e) {
    return true;
  }
}

export default class ParsersDicom {
  constructor(data, imageId) {
    //super();

    /** @private @const {!ImageId_} */
    this.imageId_ = imageId;

    /** @private @const {!ArrayBuffer_} */
    var arrayBuffer_ = data.buffer;
    var byteArray = new Uint8Array(arrayBuffer_);

    try {
      //this._dataSet2 = DicomParser.parseDicom(new Uint8Array(data));
      let loaderName = "dicom-Parser";
      const isUsingNSLoader = Config.lib.dicomLoader.isUsing;
      // IAID 파서는 비압축 Little Endian 만 읽는다. 압축(캡슐화) 픽셀·Big Endian·Deflate 는
      // 픽셀을 못 읽어 열리지 않았으므로, 그 경우에는 dicom-parser 로 읽는다.
      // if (isUsingNSLoader) {
      if (isUsingNSLoader && canUseNSLoader(data)) {
        loaderName = "IAID-DicomParser";
      }

      // var loader = LoaderParserLibs(loaderName);
      // loader.parseDicom(data);
      try {
        this._dataSet = LoaderParserLibs(loaderName).parseDicom(data);
      } catch (nsError) {
        // IAID 파서가 실패하면 dicom-parser 로 한 번 더 읽는다
        if (loaderName === "dicom-Parser") {
          throw nsError;
        }
        console.warn("IAID-DicomParser failed, retry with dicom-parser : " + nsError);
        this._dataSet = LoaderParserLibs("dicom-Parser").parseDicom(data);
      }
    } catch (ex) {
      console.log("file reading was failed : " + ex);
      const parameters = {
        title: "Warning",
        message: "This data is not supported format",
        buttonType: "OK",
        hasCloseButton: false,
        hasTodayOffButton: false
      };
      FloatMessageBox(parameters);
    }
  }

  dumpDataSet() {
    let dump = [];
    dumpDataSet(this._dataSet, dump);
    return dump;
  }
  /**
   * Series instance UID (0020,000e)
   *
   * @return {String}
   */
  seriesInstanceUID() {
    return this._dataSet.string("x0020000e");
  }

  seriesNumber() {
    return this._dataSet.string("x00200011");
  }

  /**
   * Study instance UID (0020,000d)
   *
   * @return {String}
   */
  studyInstanceUID() {
    return this._dataSet.string("x0020000d");
  }

  /**
   * Study ID
   *
   * @return {String}
   */
  studyID() {
    return this._dataSet.string("x00200010");
  }

  /**
   * Get modality (0008,0060)
   *
   * @return {String}
   */
  modality() {
    return this._dataSet.string("x00080060") || "NoneModality";
  }

  /**
   *
   * @param {*} frameIndex
   */

  /// sopClassUID 의 functional group 에서 위치를 알게되면, 이 코드를 업데이트 한다.
  //sopClassUID(frameIndex = 0){
  sopClassUID() {
    let sopClassUID = this._dataSet.string("x00080016");
    return sopClassUID;
  }

  /**
   * SOP Instance UID
   *
   * @param {*} frameIndex
   *
   * @return {*}
   */
  sopInstanceUID(frameIndex = 0) {
    let sopInstanceUID = this._findStringEverywhere(
      "x2005140f",
      "x00080018",
      frameIndex
    );
    return sopInstanceUID;
  }

  /**
   * Transfer syntax UID
   *
   * @return {*}
   */
  transferSyntaxUID() {
    return trimNull(this._dataSet.string("x00020010"));
  }

  /**
   * Study date
   *
   * @return {*}
   */
  studyDate() {
    return this._dataSet.string("x00080020") || "";
  }
  /**
   * Study time
   *
   * @return {*}
   */
  studyTime() {
    return this._dataSet.string("x00080030") || "";
  }

  /**
   * Study description
   *
   * @return {*}
   */
  studyDescription() {
    return this._dataSet.string("x00081030") || "";
  }

  /**
   * Frame of reference UID
   * @return {*}
   */
  frameOfReferenceUID() {
    return this._dataSet.string("x00200052") || "";
  }

  /**
   * Series date
   *
   * @return {*}
   */
  seriesDate() {
    return this._dataSet.string("x00080021");
  }
  /**
   * Series description
   *
   * @return {*}
   */
  seriesDescription() {
    return this._dataSet.string("x0008103e");
  }

  /**
   * Acquisition Date
   *
   * @return {*}
   */
  acquisitionDate() {
    return this._dataSet.string("x00080022");
  }

  /**
   * Acquisition Time
   *
   * @return {*}
   */
  acquisitionTime() {
    return this._dataSet.string("x00080032");
  }

  /**
   * Institution Name
   *
   * @return {*}
   */
  institutionName() {
    return this._dataSet.string("x00080080");
  }

  /**
   * Institution Address
   *
   * @return {*}
   */
  institutionAddress() {
    return this._dataSet.string("x00080081");
  }

  /**
   * Patient name
   *
   * @return {*}
   */
  patientName() {
    // return this._dataSet.string("x00100010");
    // 한글 이름이 깨지지 않게 (EUC-KR / UTF-8 복원). 뷰어 오른쪽 위 표시와 PDF 리포트가 같이 쓴다
    return decodeDicomText(this._dataSet.string("x00100010"));
  }

  /**
   * Patient ID
   *
   * @return {*}
   */
  patientID() {
    return this._dataSet.string("x00100020");
  }

  /**
   * Patient birthdate
   *
   * @return {*}
   */
  patientBirthdate() {
    return this._dataSet.string("x00100030");
  }

  /**
   * Patient sex
   *
   * @return {*}
   */
  patientSex() {
    return this._dataSet.string("x00100040");
  }

  /**
   * Patient age
   *
   * @return {*}
   */
  patientAge() {
    return this._dataSet.string("x00101010");
  }

  /**
   * Photometric interpretation
   *
   * @return {*}
   */
  photometricInterpretation() {
    return this._dataSet.string("x00280004");
  }

  planarConfiguration() {
    let planarConfiguration = this._dataSet.uint16("x00280006");

    if (typeof planarConfiguration === "undefined") {
      planarConfiguration = null;
    }

    return planarConfiguration;
  }

  samplesPerPixel() {
    return this._dataSet.uint16("x00280002");
  }

  numberOfFrames() {
    let numberOfFrames = this._dataSet.intString("x00280008");

    // need something smarter!
    if (typeof numberOfFrames === "undefined") {
      numberOfFrames = null;
    }

    return numberOfFrames;
  }

  numberOfChannels() {
    let numberOfChannels = 1;
    let photometricInterpretation = this.photometricInterpretation();

    if (
      !(
        photometricInterpretation !== "RGB" &&
        photometricInterpretation !== "PALETTE COLOR" &&
        photometricInterpretation !== "YBR_FULL" &&
        photometricInterpretation !== "YBR_FULL_422" &&
        photometricInterpretation !== "YBR_PARTIAL_422" &&
        photometricInterpretation !== "YBR_PARTIAL_420" &&
        photometricInterpretation !== "YBR_RCT"
      )
    ) {
      numberOfChannels = 3;
    }

    // make sure we return a number! (not a string!)
    return numberOfChannels;
  }

  invert() {
    let photometricInterpretation = this.photometricInterpretation();

    return photometricInterpretation === "MONOCHROME1" ? true : false;
  }

  pixelDataElement() {
    return this._dataSet.getElement("x7fe00010");
    //return this._dataSet.elements["x7fe00010"];
  }

  imageOrientation(frameIndex = 0) {
    // expect frame index to start at 0!
    let imageOrientation = this._findStringEverywhere(
      "x00209116",
      "x00200037",
      frameIndex
    );

    // format image orientation ('1\0\0\0\1\0') to array containing 6 numbers
    if (imageOrientation) {
      // make sure we return a number! (not a string!)
      // might not need to split (floatString + index)
      //imageOrientation = imageOrientation.split('\\').map(UtilsCore.stringToNumber);
      imageOrientation = imageOrientation.split("\\").map(stringToNumber);
    }

    return imageOrientation;
  }

  /**
   * get X-Ray Tube Current
   * @returns
   */
  XRayTubeCurrent() {
    const value = this._dataSet.intString("x00181151");
    return value;
  }

  /**
   * get KVP
   * @param {*} KVP
   */
  KVP() {
    const value = this._dataSet.intString("x00180060");
    return value;
  }

  /**
   * get image comment
   * @param {*} frameIndex
   */
  imageComment() {
    const value = this._dataSet.string("x00204000");
    return value;
  }

  /**
   * get study comment
   * @param {*} frameIndex
   */
  studyComment() {
    const value = this._dataSet.string("x00324000");
    return value;
  }

  referencedSegmentNumber(frameIndex = 0) {
    let referencedSegmentNumber = -1;
    let referencedSegmentNumberElement = this._findInGroupSequence(
      "x52009230",
      "x0062000a",
      frameIndex
    );

    if (referencedSegmentNumberElement !== null) {
      referencedSegmentNumber = referencedSegmentNumberElement.uint16(
        "x0062000b"
      );
    }

    return referencedSegmentNumber;
  }
  rightHanded() {
    return this._rightHanded;
  }
  pixelAspectRatio() {
    let pixelAspectRatio = [
      this._dataSet.intString("x00280034", 0),
      this._dataSet.intString("x00280034", 1)
    ];

    // need something smarter!
    if (typeof pixelAspectRatio[0] === "undefined") {
      pixelAspectRatio = null;
    }

    // make sure we return a number! (not a string!)
    return pixelAspectRatio;
  }

  // information for MR modality
  /**
   * get repetition time
   * @return {string}
   */
  fieldStrenth() {
    const value = this._dataSet.string("x00180087");
    return value;
  }
  /**
   * get repetition time
   * @return {string}
   */
  repetitionTime() {
    const value = this._dataSet.string("x00180080");
    return value;
  }
  /**
   * get echoTime
   * @return {string}
   */
  echoTime() {
    const value = this._dataSet.string("x00180081");
    return value;
  }

  imagePosition(frameIndex = 0) {
    let imagePosition = this._findStringEverywhere(
      "x00209113",
      "x00200032",
      frameIndex
    );

    // format image orientation ('1\0\0\0\1\0') to array containing 6 numbers
    if (imagePosition) {
      // make sure we return a number! (not a string!)
      //imagePosition = imagePosition.split('\\').map(UtilsCore.stringToNumber);
      imagePosition = imagePosition.split("\\").map(stringToNumber);
    }

    return imagePosition;
  }

  instanceNumber(frameIndex = 0) {
    let instanceNumber = null;
    // first look for frame!
    // per frame functionnal group sequence
    let perFrameFunctionnalGroupSequence = this._dataSet.elements.x52009230;

    if (typeof perFrameFunctionnalGroupSequence !== "undefined") {
      if (
        perFrameFunctionnalGroupSequence.items[frameIndex].dataSet.elements
          .x2005140f
      ) {
        let planeOrientationSequence =
          perFrameFunctionnalGroupSequence.items[frameIndex].dataSet.elements
            .x2005140f.items[0].dataSet;
        instanceNumber = planeOrientationSequence.intString("x00200013");
      } else {
        instanceNumber = this._dataSet.intString("x00200013");

        if (typeof instanceNumber === "undefined") {
          instanceNumber = null;
        }
      }
    } else {
      // should we default to undefined??
      // default orientation
      instanceNumber = this._dataSet.intString("x00200013");

      if (typeof instanceNumber === "undefined") {
        instanceNumber = null;
      }
    }

    return instanceNumber;
  }

  pixelSpacing(frameIndex = 0) {
    // expect frame index to start at 0!
    let pixelSpacing = this._findStringEverywhere(
      "x00289110",
      "x00280030",
      frameIndex
    );

    if (pixelSpacing === null) {
      pixelSpacing = this._dataSet.string("x00181164");

      if (typeof pixelSpacing === "undefined") {
        pixelSpacing = null;
      }
    }

    if (pixelSpacing) {
      const splittedSpacing = pixelSpacing.split("\\");
      if (splittedSpacing.length !== 2) {
        console.error(
          `DICOM spacing format is not supported (could not split string on "\\"): ${pixelSpacing}`
        );
        pixelSpacing = null;
      } else {
        //pixelSpacing = splittedSpacing.map(UtilsCore.stringToNumber);
        pixelSpacing = splittedSpacing.map(stringToNumber);
      }
    }

    return pixelSpacing;
  }

  performedProcedureStepID() {
    return this._dataSet.string("x00400253");
  }

  ultrasoundRegions(frameIndex = 0) {
    const sequence = this._dataSet.elements["x00186011"];

    if (!sequence || !sequence.items) {
      return [];
    }

    const ultrasoundRegions = [];

    sequence.items.forEach(item => {
      ultrasoundRegions.push({
        x0: item.dataSet.uint32("x00186018"),
        y0: item.dataSet.uint32("x0018601a"),
        x1: item.dataSet.uint32("x0018601c"),
        y1: item.dataSet.uint32("x0018601e"),
        axisX: item.dataSet.int32("x00186020") || null, // optional
        axisY: item.dataSet.int32("x00186022") || null, // optional
        unitsX: this._getUnitsName(item.dataSet.uint16("x00186024")),
        unitsY: this._getUnitsName(item.dataSet.uint16("x00186026")),
        deltaX: item.dataSet.double("x0018602c"),
        deltaY: item.dataSet.double("x0018602e")
      });
    });

    return ultrasoundRegions;
  }

  frameTime(frameIndex = 0) {
    let frameIncrementPointer = this._dataSet.uint16("x00280009", 1);
    let frameRate = this._dataSet.intString("x00082144");
    let frameTime;

    if (typeof frameIncrementPointer === "number") {
      frameIncrementPointer = frameIncrementPointer.toString(16);
      frameTime = this._dataSet.floatString("x0018" + frameIncrementPointer);
    }

    if (typeof frameTime === "undefined" && typeof frameRate === "number") {
      frameTime = 1000 / frameRate;
    }

    if (typeof frameTime === "undefined") {
      frameTime = null;
    }

    return frameTime;
  }

  rows(frameIndex = 0) {
    let rows = this._dataSet.uint16("x00280010");

    if (typeof rows === "undefined") {
      rows = null;
      // print warning at least...
    }

    return rows;
  }

  columns(frameIndex = 0) {
    let columns = this._dataSet.uint16("x00280011");

    if (typeof columns === "undefined") {
      //columns = null;
      columns = undefined;
      // print warning at least...
    }

    return columns;
  }

  pixelType(frameIndex = 0) {
    // 0 integer, 1 float
    // dicom only support integers
    return 0;
  }
  bitsAllocated(frameIndex = 0) {
    // expect frame index to start at 0!
    let bitsAllocated = this._dataSet.uint16("x00280100");
    return bitsAllocated;
  }

  highBit(frameIndex = 0) {
    // expect frame index to start at 0!
    let highBit = this._dataSet.uint16("x00280102");
    return highBit;
  }

  rescaleIntercept(frameIndex = 0) {
    let value = this._findFloatStringInFrameGroupSequence(
      "x00289145",
      "x00281052",
      frameIndex
    );
    if (value === null || value === undefined) value = 0;

    return value;
    //return this._findFloatStringInFrameGroupSequence('x00289145', 'x00281052', frameIndex);
  }

  rescaleSlope(frameIndex = 0) {
    var value = this._findFloatStringInFrameGroupSequence(
      "x00289145",
      "x00281053",
      frameIndex
    );
    if (value === null || value === undefined) value = 1;
    return value;
    //return this._findFloatStringInFrameGroupSequence('x00289145', 'x00281053', frameIndex);
  }

  windowCenter(frameIndex = 0) {
    return this._findFloatStringInFrameGroupSequence(
      "x00289132",
      "x00281050",
      frameIndex
    );
  }

  windowWidth(frameIndex = 0) {
    return this._findFloatStringInFrameGroupSequence(
      "x00289132",
      "x00281051",
      frameIndex
    );
  }

  sliceThickness(frameIndex = 0) {
    return this._findFloatStringInFrameGroupSequence(
      "x00289110",
      "x00180050",
      frameIndex
    );
  }

  sliceLocation(frameIndex = 0) {
    return this._findFloatStringInFrameGroupSequence(
      "x00289110",
      "x00201041",
      frameIndex
    );
    //return this._dataSet.floatString('x00201041');
  }

  spacingBetweenSlices(frameIndex = 0) {
    let spacing = this._dataSet.floatString("x00180088");

    if (typeof spacing === "undefined") {
      spacing = null;
    }

    return spacing;
  }

  dimensionIndexValues(frameIndex = 0) {
    let dimensionIndexValues = null;

    // try to get it from enhanced MR images
    // per-frame functionnal group sequence
    let perFrameFunctionnalGroupSequence = this._dataSet.elements.x52009230;

    if (typeof perFrameFunctionnalGroupSequence !== "undefined") {
      let frameContentSequence =
        perFrameFunctionnalGroupSequence.items[frameIndex].dataSet.elements
          .x00209111;
      if (frameContentSequence !== undefined && frameContentSequence !== null) {
        frameContentSequence = frameContentSequence.items[0].dataSet;
        let dimensionIndexValuesElt = frameContentSequence.elements.x00209157;
        if (
          dimensionIndexValuesElt !== undefined &&
          dimensionIndexValuesElt !== null
        ) {
          // /4 because UL
          let nbValues = dimensionIndexValuesElt.length / 4;
          dimensionIndexValues = [];

          for (let i = 0; i < nbValues; i++) {
            dimensionIndexValues.push(
              frameContentSequence.uint32("x00209157", i)
            );
          }
        }
      }
    }

    return dimensionIndexValues;
  }

  inStackPositionNumber(frameIndex = 0) {
    let inStackPositionNumber = null;

    // try to get it from enhanced MR images
    // per-frame functionnal group sequence
    let perFrameFunctionnalGroupSequence = this._dataSet.elements.x52009230;

    if (typeof perFrameFunctionnalGroupSequence !== "undefined") {
      // NOT A PHILIPS TRICK!
      let philipsPrivateSequence =
        perFrameFunctionnalGroupSequence.items[frameIndex].dataSet.elements
          .x00209111.items[0].dataSet;
      inStackPositionNumber = philipsPrivateSequence.uint32("x00209057");
    } else {
      inStackPositionNumber = null;
    }

    return inStackPositionNumber;
  }

  stackID(frameIndex = 0) {
    let stackID = null;

    // try to get it from enhanced MR images
    // per-frame functionnal group sequence
    let perFrameFunctionnalGroupSequence = this._dataSet.elements.x52009230;

    if (typeof perFrameFunctionnalGroupSequence !== "undefined") {
      // NOT A PHILIPS TRICK!
      let philipsPrivateSequence =
        perFrameFunctionnalGroupSequence.items[frameIndex].dataSet.elements
          .x00209111.items[0].dataSet;
      stackID = philipsPrivateSequence.intString("x00209056");
    } else {
      stackID = null;
    }

    return stackID;
  }
  pixelRepresentation(frameIndex = 0) {
    let pixelRepresentation = this._dataSet.uint16("x00280103");
    return pixelRepresentation;
  }

  pixelPaddingValue(frameIndex = 0) {
    let padding = this._dataSet.int16("x00280120");

    if (typeof padding === "undefined") {
      padding = null;
    }

    return padding;
  }

  extractPixelData(frameIndex = 0) {
    // decompress
    let decompressedData = this._decodePixelData(frameIndex);

    let numberOfChannels = this.numberOfChannels();

    if (numberOfChannels > 1) {
      return this._convertColorSpace(decompressedData);
    } else {
      return decompressedData;
    }
  }

  getEncapsulatedImageFrame(frameIndex) {
    if (
      this._dataSet.elements.x7fe00010 &&
      this._dataSet.elements.x7fe00010.basicOffsetTable.length
    ) {
      // Basic Offset Table is not empty
      return DicomParser.readEncapsulatedImageFrame(
        this._dataSet,
        this._dataSet.elements.x7fe00010,
        frameIndex
      );
    }

    if (this.framesAreFragmented()) {
      // Basic Offset Table is empty
      return DicomParser.readEncapsulatedImageFrame(
        this._dataSet,
        this._dataSet.elements.x7fe00010,
        frameIndex,
        DicomParser.createJPEGBasicOffsetTable(
          this._dataSet,
          this._dataSet.elements.x7fe00010
        )
      );
    }

    return DicomParser.readEncapsulatedPixelDataFromFragments(
      this._dataSet,
      this._dataSet.elements.x7fe00010,
      frameIndex
    );
  }

  /**
   * Get min/max values in array
   *
   * @param {*} pixelData
   *
   * @return {*}
   */
  minMaxPixelData(pixelData = []) {
    let minMax = [Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY];
    let numPixels = pixelData.length;
    for (let index = 0; index < numPixels; index++) {
      let spv = pixelData[index];
      minMax[0] = Math.min(minMax[0], spv);
      minMax[1] = Math.max(minMax[1], spv);
    }

    return minMax;
  }

  getModalityLUTSequence() {
    return this._dataSet.elements.x00283000;
  }

  getVOILutSequence() {
    return this._dataSet.elements.x00283010;
  }

  /**
   * private methods
   */
  _findFloatStringInGroupSequence(sequence, subsequence, tag, index) {
    let dataInGroupSequence = this._dataSet.floatString(tag);

    // try to get it from enhanced MR images
    // per-frame functionnal group
    if (typeof dataInGroupSequence === "undefined") {
      dataInGroupSequence = this._findInGroupSequence(
        sequence,
        subsequence,
        index
      );

      if (dataInGroupSequence !== null) {
        return dataInGroupSequence.floatString(tag);
      }
    }

    return dataInGroupSequence;
  }

  _findFloatStringInFrameGroupSequence(subsequence, tag, index) {
    return (
      this._findFloatStringInGroupSequence("x52009229", subsequence, tag, 0) ||
      this._findFloatStringInGroupSequence("x52009230", subsequence, tag, index)
    );
  }
  _findStringInSequence(sequenceTag, tag, index) {
    const sequence = this._dataSet.elements[sequenceTag];

    let targetString;
    if (sequence) {
      targetString = sequence.items[0].dataSet.string(tag);
    }

    if (typeof targetString === "undefined") {
      targetString = null;
    }

    return targetString;
  }
  _findInGroupSequence(sequence, subsequence, index) {
    let functionalGroupSequence = this._dataSet.elements[sequence];

    if (typeof functionalGroupSequence !== "undefined") {
      let inSequence =
        functionalGroupSequence.items[index].dataSet.elements[subsequence];

      if (typeof inSequence !== "undefined") {
        return inSequence.items[0].dataSet;
      }
    }

    return null;
  }
  _findInGroupSequence(sequence, subsequence, index) {
    let functionalGroupSequence = this._dataSet.elements[sequence];

    if (typeof functionalGroupSequence !== "undefined") {
      let inSequence =
        functionalGroupSequence.items[index].dataSet.elements[subsequence];

      if (typeof inSequence !== "undefined") {
        return inSequence.items[0].dataSet;
      }
    }
    return null;
  }
  _findStringInGroupSequence(sequence, subsequence, tag, index) {
    // index = 0 if shared!!!
    let dataSet = this._findInGroupSequence(sequence, subsequence, index);

    if (dataSet !== null) {
      return dataSet.string(tag);
    }

    return null;
  }
  _findStringInFrameGroupSequence(subsequence, tag, index) {
    return (
      this._findStringInGroupSequence("x52009229", subsequence, tag, 0) ||
      this._findStringInGroupSequence("x52009230", subsequence, tag, index)
    );
  }

  _findStringEverywhere(subsequence, tag, index) {
    let targetString = this._findStringInFrameGroupSequence(
      subsequence,
      tag,
      index
    );
    // PET MODULE
    if (targetString === null) {
      const petModule = "x00540022";
      targetString = this._findStringInSequence(petModule, tag);
    }

    if (targetString === null) {
      targetString = this._dataSet.string(tag);
    }

    if (typeof targetString === "undefined") {
      targetString = null;
    }

    return targetString;
  }

  _decodePixelData(frameIndex = 0) {
    // if compressed..?
    let transferSyntaxUID = this.transferSyntaxUID();

    // find compression scheme
    if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.90" ||
      // JPEG 2000 Lossless
      transferSyntaxUID === "1.2.840.10008.1.2.4.91"
    ) {
      // JPEG 2000 Lossy
      return this._decodeJ2K(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.92" ||
      // JPEG 2000 Part 2 Multi-component Lossless
      transferSyntaxUID === "1.2.840.10008.1.2.4.93"
      // JPEG 2000 Part 2 Multi-component
    ) {
      return this._decodeJ2K(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.80" ||
      // JPEG-LS Lossless
      transferSyntaxUID === "1.2.840.10008.1.2.4.81"
      // JPEG-LS Lossy (Near-Lossless)
    ) {
      return this._decodeJPEGLS(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.201" ||
      // HTJ2K Lossless
      transferSyntaxUID === "1.2.840.10008.1.2.4.202" ||
      // HTJ2K Lossless RPCL
      transferSyntaxUID === "1.2.840.10008.1.2.4.203"
      // HTJ2K
    ) {
      return this._decodeHTJ2K(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.5"
      // decodeRLE
    ) {
      return this._decodeRLE(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.57" ||
      // JPEG Lossless, Nonhierarchical (Processes 14)
      transferSyntaxUID === "1.2.840.10008.1.2.4.70"
    ) {
      // JPEG Lossless, Nonhierarchical (Processes 14 [Selection 1])
      return this._decodeJPEGLossless(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2.4.50" ||
      // JPEG Baseline lossy process 1 (8 bit)
      transferSyntaxUID === "1.2.840.10008.1.2.4.51"
    ) {
      // JPEG Baseline lossy process 2 & 4 (12 bit)
      return this._decodeJPEGBaseline(frameIndex);
    } else if (
      transferSyntaxUID === "1.2.840.10008.1.2" ||
      // Implicit VR Little Endian
      transferSyntaxUID === "1.2.840.10008.1.2.1" ||
      // Deflated Explicit VR Little Endian: 파싱 때 이미 풀려 있어 비압축과 같다 (DicomParserAdapter 의 inflater)
      transferSyntaxUID === "1.2.840.10008.1.2.1.99"
    ) {
      // Explicit VR Little Endian
      return this._decodeUncompressed(frameIndex);
    } else if (transferSyntaxUID === "1.2.840.10008.1.2.2") {
      // Explicit VR Big Endian
      let frame = this._decodeUncompressed(frameIndex);
      // and sawp it!
      return this._swapFrame(frame);
    } else {
      throw new Error("no decoder for transfer syntax");
    }
  }
  // github.com/chafey/cornerstoneWADOImageLoader/blob/master/src/imageLoader/wadouri/getEncapsulatedImageFrame.js
  framesAreFragmented() {
    const numberOfFrames = this._dataSet.intString("x00280008");
    const pixelDataElement = this._dataSet.elements.x7fe00010;

    return numberOfFrames !== pixelDataElement.fragments.length;
  }
  _decodeJpx(frameIndex = 0) {
    const jpxImage = new JpxImage();
    // https://github.com/OHIF/image-JPEG2000/issues/6
    // It currently returns either Int16 or Uint16 based on whether the codestream is signed or not.
    jpxImage.parse(this.getEncapsulatedImageFrame(frameIndex));

    if (jpxImage.componentsCount !== 1) {
      throw new Error(
        "JPEG2000 decoder returned a componentCount of ${componentsCount}, when 1 is expected"
      );
    }

    if (jpxImage.tiles.length !== 1) {
      throw new Error(
        "JPEG2000 decoder returned a tileCount of ${tileCount}, when 1 is expected"
      );
    }

    return jpxImage.tiles[0].items;
    //return undefined;
  }

  _decodeOpenJPEG(frameIndex = 0) {
    const encodedPixelData = this.getEncapsulatedImageFrame(frameIndex);
    const bytesPerPixel = this.bitsAllocated(frameIndex) <= 8 ? 1 : 2;
    const signed = this.pixelRepresentation(frameIndex) === 1;
    const dataPtr = openJPEG._malloc(encodedPixelData.length);

    openJPEG.writeArrayToMemory(encodedPixelData, dataPtr);

    // create param outpout
    const imagePtrPtr = openJPEG._malloc(4);
    const imageSizePtr = openJPEG._malloc(4);
    const imageSizeXPtr = openJPEG._malloc(4);
    const imageSizeYPtr = openJPEG._malloc(4);
    const imageSizeCompPtr = openJPEG._malloc(4);
    const ret = openJPEG.ccall(
      "jp2_decode",
      "number",
      ["number", "number", "number", "number", "number", "number", "number"],
      [
        dataPtr,
        encodedPixelData.length,
        imagePtrPtr,
        imageSizePtr,
        imageSizeXPtr,
        imageSizeYPtr,
        imageSizeCompPtr
      ]
    );
    const imagePtr = openJPEG.getValue(imagePtrPtr, "*");

    if (ret !== 0) {
      console.log("[opj_decode] decoding failed!");
      openJPEG._free(dataPtr);
      openJPEG._free(imagePtr);
      openJPEG._free(imageSizeXPtr);
      openJPEG._free(imageSizeYPtr);
      openJPEG._free(imageSizePtr);
      openJPEG._free(imageSizeCompPtr);

      return;
    }

    // Copy the data from the EMSCRIPTEN heap into the correct type array
    const length =
      openJPEG.getValue(imageSizeXPtr, "i32") *
      openJPEG.getValue(imageSizeYPtr, "i32") *
      openJPEG.getValue(imageSizeCompPtr, "i32");
    const src32 = new Int32Array(openJPEG.HEAP32.buffer, imagePtr, length);
    let pixelData;

    if (bytesPerPixel === 1) {
      if (Uint8Array.from) {
        pixelData = Uint8Array.from(src32);
      } else {
        pixelData = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
          pixelData[i] = src32[i];
        }
      }
    } else if (signed) {
      if (Int16Array.from) {
        pixelData = Int16Array.from(src32);
      } else {
        pixelData = new Int16Array(length);
        for (let i = 0; i < length; i++) {
          pixelData[i] = src32[i];
        }
      }
    } else if (Uint16Array.from) {
      pixelData = Uint16Array.from(src32);
    } else {
      pixelData = new Uint16Array(length);
      for (let i = 0; i < length; i++) {
        pixelData[i] = src32[i];
      }
    }

    openJPEG._free(dataPtr);
    openJPEG._free(imagePtrPtr);
    openJPEG._free(imagePtr);
    openJPEG._free(imageSizePtr);
    openJPEG._free(imageSizeXPtr);
    openJPEG._free(imageSizeYPtr);
    openJPEG._free(imageSizeCompPtr);

    return pixelData;
  }

  _decodeJ2K(frameIndex = 0) {
    // 전역 OpenJPEG 를 읽는 <script> 가 없어 늘 jpx 로만 풀었다.
    // jpx 는 무손실인데도 값이 1씩 달라지고 컬러(성분 3개)는 풀지 못해, OpenJPEG 를 먼저 쓰고
    // 만들기나 풀기에 실패할 때만 jpx 로 넘어간다.
    if (typeof OpenJPEG === "undefined") {
      // OpenJPEG decoder not loaded (public/index.html 의 codecs/openJPEG-DynamicMemory-browser.js)
      return this._decodeJpx(frameIndex);
    }

    if (!openJPEG) {
      try {
        openJPEG = OpenJPEG();
      } catch (e) {
        console.warn("OpenJPEG failed to initialize : " + e);
        openJPEG = null;
      }
      if (!openJPEG || !openJPEG._jp2_decode) {
        // OpenJPEG failed to initialize
        openJPEG = null;
        return this._decodeJpx(frameIndex);
      }
    }

    // return this._decodeOpenJPEG(frameIndex);
    const pixelData = this._decodeOpenJPEG(frameIndex);
    if (pixelData === undefined || pixelData === null) {
      return this._decodeJpx(frameIndex);
    }
    return pixelData;
  }

  /**
   * WebAssembly 디코더가 돌려준 바이트(WASM 메모리를 가리킴)를 복사해 픽셀 배열로 만든다.
   * 8비트 이하는 Uint8, 그 이상은 Pixel Representation 에 따라 Int16 / Uint16 (리틀 엔디안).
   */
  _pixelsFromDecodedBytes(decodedBytes, frameIndex = 0) {
    const copy = new Uint8Array(decodedBytes.length);
    copy.set(decodedBytes);
    if (this.bitsAllocated(frameIndex) <= 8) {
      return copy;
    }
    return this.pixelRepresentation(frameIndex) === 1
      ? new Int16Array(copy.buffer)
      : new Uint16Array(copy.buffer);
  }

  /** public/index.html 이 페이지를 열 때 준비해 둔 WebAssembly 디코더 */
  _wasmCodec(name) {
    const codecs = typeof window !== "undefined" ? window.__iaidCodecs : undefined;
    const codec = codecs && codecs[name];
    if (!codec) {
      throw new Error(name + " decoder is not loaded");
    }
    return codec;
  }

  // JPEG-LS (CharLS)
  _decodeJPEGLS(frameIndex = 0) {
    const charls = this._wasmCodec("charls");
    const encodedPixelData = this.getEncapsulatedImageFrame(frameIndex);
    const decoder = new charls.JpegLSDecoder();
    try {
      decoder.getEncodedBuffer(encodedPixelData.length).set(encodedPixelData);
      decoder.decode();
      return this._pixelsFromDecodedBytes(decoder.getDecodedBuffer(), frameIndex);
    } finally {
      decoder.delete();
    }
  }

  // HTJ2K, High-Throughput JPEG 2000 (OpenJPH)
  _decodeHTJ2K(frameIndex = 0) {
    const openjph = this._wasmCodec("openjph");
    const encodedPixelData = this.getEncapsulatedImageFrame(frameIndex);
    const decoder = new openjph.HTJ2KDecoder();
    try {
      decoder.getEncodedBuffer(encodedPixelData.length).set(encodedPixelData);
      decoder.decode();
      return this._pixelsFromDecodedBytes(decoder.getDecodedBuffer(), frameIndex);
    } finally {
      decoder.delete();
    }
  }

  _decodeRLE(frameIndex = 0) {
    const bitsAllocated = this.bitsAllocated(frameIndex);
    const planarConfiguration = this.planarConfiguration();
    const columns = this.columns();
    const rows = this.rows();
    const samplesPerPixel = this.samplesPerPixel(frameIndex);
    const pixelRepresentation = this.pixelRepresentation(frameIndex);

    // format data for the RLE decoder
    const imageFrame = {
      pixelRepresentation,
      bitsAllocated,
      planarConfiguration,
      columns,
      rows,
      samplesPerPixel
    };

    const pixelData = DicomParser.readEncapsulatedPixelDataFromFragments(
      this._dataSet,
      this._dataSet.elements.x7fe00010,
      frameIndex
    );

    const decoded = RLEDecoder(imageFrame, pixelData);
    return decoded.pixelData;
  }

  _decodeJPEGLossless(frameIndex = 0) {
    let encodedPixelData = this.getEncapsulatedImageFrame(frameIndex);
    let pixelRepresentation = this.pixelRepresentation(frameIndex);
    let bitsAllocated = this.bitsAllocated(frameIndex);
    let byteOutput = bitsAllocated <= 8 ? 1 : 2;
    let decoder = new Jpeg.lossless.Decoder();
    let decompressedData = decoder.decode(
      encodedPixelData.buffer,
      encodedPixelData.byteOffset,
      encodedPixelData.length,
      byteOutput
    );

    if (pixelRepresentation === 0) {
      if (byteOutput === 2) {
        return new Uint16Array(decompressedData.buffer);
      } else {
        // untested!
        return new Uint8Array(decompressedData.buffer);
      }
    } else {
      return new Int16Array(decompressedData.buffer);
    }
  }

  _decodeJPEGBaseline(frameIndex = 0) {
    let encodedPixelData = this.getEncapsulatedImageFrame(frameIndex);
    let rows = this.rows(frameIndex);
    let columns = this.columns(frameIndex);
    let bitsAllocated = this.bitsAllocated(frameIndex);
    let jpegBaseline = new JpegImage();
    jpegBaseline.parse(encodedPixelData);

    if (bitsAllocated === 8) {
      return jpegBaseline.getData(columns, rows);
    } else if (bitsAllocated === 16) {
      return jpegBaseline.getData16(columns, rows);
    }
  }

  _decodeUncompressed(frameIndex = 0) {
    let pixelRepresentation = this.pixelRepresentation(frameIndex);
    let bitsAllocated = this.bitsAllocated(frameIndex);
    //let pixelDataElement = this._dataSet.elements["x7fe00010"];
    let pixelDataElement = this.pixelDataElement();
    let pixelDataOffset = pixelDataElement.dataOffset;
    let numberOfChannels = this.numberOfChannels();
    let numPixels =
      this.rows(frameIndex) * this.columns(frameIndex) * numberOfChannels;
    let frameOffset = 0;
    let buffer = this._dataSet.byteArray.buffer;

    if (pixelRepresentation === 0 && bitsAllocated === 8) {
      // unsigned 8 bit
      frameOffset = pixelDataOffset + frameIndex * numPixels;
      return new Uint8Array(buffer, frameOffset, numPixels);
    } else if (pixelRepresentation === 0 && bitsAllocated === 16) {
      // unsigned 16 bit
      frameOffset = pixelDataOffset + frameIndex * numPixels * 2;
      return new Uint16Array(buffer, frameOffset, numPixels);
    } else if (pixelRepresentation === 1 && bitsAllocated === 16) {
      // signed 16 bit
      frameOffset = pixelDataOffset + frameIndex * numPixels * 2;
      return new Int16Array(buffer, frameOffset, numPixels);
    } else if (pixelRepresentation === 0 && bitsAllocated === 32) {
      // unsigned 32 bit
      frameOffset = pixelDataOffset + frameIndex * numPixels * 4;
      return new Uint32Array(buffer, frameOffset, numPixels);
    } else if (pixelRepresentation === 0 && bitsAllocated === 1) {
      let newBuffer = new ArrayBuffer(numPixels);
      let newArray = new Uint8Array(newBuffer);

      frameOffset = pixelDataOffset + frameIndex * numPixels;
      let index = 0;

      let bitStart = frameIndex * numPixels;
      let bitEnd = frameIndex * numPixels + numPixels;

      let byteStart = Math.floor(bitStart / 8);
      let bitStartOffset = bitStart - byteStart * 8;
      let byteEnd = Math.ceil(bitEnd / 8);

      let targetBuffer = new Uint8Array(buffer, pixelDataOffset);

      for (let i = byteStart; i <= byteEnd; i++) {
        while (bitStartOffset < 8) {
          switch (bitStartOffset) {
            case 0:
              newArray[index] = targetBuffer[i] & 0x0001;
              break;
            case 1:
              newArray[index] = (targetBuffer[i] >>> 1) & 0x0001;
              break;
            case 2:
              newArray[index] = (targetBuffer[i] >>> 2) & 0x0001;
              break;
            case 3:
              newArray[index] = (targetBuffer[i] >>> 3) & 0x0001;
              break;
            case 4:
              newArray[index] = (targetBuffer[i] >>> 4) & 0x0001;
              break;
            case 5:
              newArray[index] = (targetBuffer[i] >>> 5) & 0x0001;
              break;
            case 6:
              newArray[index] = (targetBuffer[i] >>> 6) & 0x0001;
              break;
            case 7:
              newArray[index] = (targetBuffer[i] >>> 7) & 0x0001;
              break;
            default:
              break;
          }

          bitStartOffset++;
          index++;
          // if return..
          if (index >= numPixels) {
            return newArray;
          }
        }
        bitStartOffset = 0;
      }
    }
  }

  _interpretAsRGB(photometricInterpretation) {
    const rgbLikeTypes = ["RGB", "YBR_RCT", "YBR_ICT", "YBR_FULL_422"];

    return rgbLikeTypes.indexOf(photometricInterpretation) !== -1;
  }

  _convertColorSpace(uncompressedData) {
    let rgbData = null;
    let photometricInterpretation = this.photometricInterpretation();
    let planarConfiguration = this.planarConfiguration();

    const interpretAsRGB = this._interpretAsRGB(photometricInterpretation);
    if (interpretAsRGB && planarConfiguration === 0) {
      // ALL GOOD, ALREADY ORDERED
      // planar or non planar planarConfiguration
      rgbData = uncompressedData;
    } else if (interpretAsRGB && planarConfiguration === 1) {
      if (uncompressedData instanceof Int8Array) {
        rgbData = new Int8Array(uncompressedData.length);
      } else if (uncompressedData instanceof Uint8Array) {
        rgbData = new Uint8Array(uncompressedData.length);
      } else if (uncompressedData instanceof Int16Array) {
        rgbData = new Int16Array(uncompressedData.length);
      } else if (uncompressedData instanceof Uint16Array) {
        rgbData = new Uint16Array(uncompressedData.length);
      } else {
        const error = new Error(`unsuported typed array: ${uncompressedData}`);
        throw error;
      }

      let numPixels = uncompressedData.length / 3;
      let rgbaIndex = 0;
      let rIndex = 0;
      let gIndex = numPixels;
      let bIndex = numPixels * 2;
      for (let i = 0; i < numPixels; i++) {
        rgbData[rgbaIndex++] = uncompressedData[rIndex++]; // red
        rgbData[rgbaIndex++] = uncompressedData[gIndex++]; // green
        rgbData[rgbaIndex++] = uncompressedData[bIndex++]; // blue
      }
    } else if (photometricInterpretation === "YBR_FULL") {
      if (uncompressedData instanceof Int8Array) {
        rgbData = new Int8Array(uncompressedData.length);
      } else if (uncompressedData instanceof Uint8Array) {
        rgbData = new Uint8Array(uncompressedData.length);
      } else if (uncompressedData instanceof Int16Array) {
        rgbData = new Int16Array(uncompressedData.length);
      } else if (uncompressedData instanceof Uint16Array) {
        rgbData = new Uint16Array(uncompressedData.length);
      } else {
        const error = new Error(`unsuported typed array: ${uncompressedData}`);
        throw error;
      }

      // https://github.com/chafey/cornerstoneWADOImageLoader/blob/master/src/decodeYBRFull.js
      let nPixels = uncompressedData.length / 3;
      let ybrIndex = 0;
      let rgbaIndex = 0;
      for (let i = 0; i < nPixels; i++) {
        let y = uncompressedData[ybrIndex++];
        let cb = uncompressedData[ybrIndex++];
        let cr = uncompressedData[ybrIndex++];
        rgbData[rgbaIndex++] = y + 1.402 * (cr - 128); // red
        rgbData[rgbaIndex++] = y - 0.34414 * (cb - 128) - 0.71414 * (cr - 128); // green
        rgbData[rgbaIndex++] = y + 1.772 * (cb - 128); // blue
        // rgbData[rgbaIndex++] = 255; //alpha
      }
    } else {
      const error = new Error(
        `photometric interpolation not supported: ${photometricInterpretation}`
      );
      throw error;
    }

    return rgbData;
  }

  /**
   * Swap bytes in frame.
   */
  _swapFrame(frame) {
    // swap bytes ( if 8bits (1byte), nothing to swap)
    let bitsAllocated = this.bitsAllocated();

    if (bitsAllocated === 16) {
      for (let i = 0; i < frame.length; i++) {
        frame[i] = this._swap16(frame[i]);
      }
    } else if (bitsAllocated === 32) {
      for (let i = 0; i < frame.length; i++) {
        frame[i] = this._swap32(frame[i]);
      }
    }

    return frame;
  }

  _getUnitsName(value) {
    const units = {
      0: "none",
      1: "percent",
      2: "dB",
      3: "cm",
      4: "seconds",
      5: "hertz",
      6: "dB/seconds",
      7: "cm/sec",
      8: "cm2",
      9: "cm2/sec",
      10: "cm3",
      11: "cm3/sec",
      12: "degrees"
    };

    return units.hasOwnProperty(value) ? units[value] : "none";
  }
}
